<script setup>
const props = defineProps({ 
  isLargeScreen : Boolean
})
</script>

<template>
  <div v-if="!props.isLargeScreen" style="min-height: 270px; width: 300px; height: 250px; margin: 10px; padding: 0; display: inline-flex; justify-content: center; align-items: center; background: rgba(0,0,0,.2);">
    <!-- 640px以下の画面でのみ表示 -->
    <div id="5d1e8f412f4a2c46ae0390555110ade1" ></div>
  </div>
</template>

<style scoped>
</style>